<template>
  <!--Evento emitido ao interagir com o checkbox 
      @event change
      @property {Boolean} value - Valor atual do checkbox
 -->
  <v-checkbox
    v-bind="$attrs"
    class="zoox-checkbox zoox-component"
    :class="{small}"
    :value="value"
    :indeterminate-icon="indeterminateIcon"
    :label="label"
    :input-value="value"
    :color="color"
    :disabled="disabled"
    :on-icon="onIcon"
    :off-icon="offIcon"
    :hide-details="hideDetails"
    v-on="$listeners"
    @change="$emit('change', $event)"
  >
    <template #append>
      <!--@slot Slot para adição de um elemento em frente o checkbox -->
      <slot name="append"></slot>
    </template>

    <template #label>
      <!--@slot Slot para customização da label do checkbox -->
      <slot name="label"></slot>
    </template>

    <template #prepend>
      <!--@slot Slot para adição de um elemento atrás do checkbox -->
      <slot name="prepend"></slot>
    </template>

    <!--@slot Slot padrão do componente -->
    <slot></slot>
  </v-checkbox>
</template>

<script>
/**
 * @displayName Checkbox
 */
export default {
  name: 'ZCheckbox',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Denfine a label do checkbox
     */
    label: {
      type: String,
    },
    /**
     * Desabilita o checkbox
     */
    disabled: {
      type: Boolean,
    },
    /**
     * Valor do checkbox
     *
     * @modelName value
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * Cor do checkbox
     */
    color: {
      type: String,
      default: 'var(--black-300)',
    },
    /**
     * Icone do checkbox quando estiver marcado
     */
    onIcon: {
      type: String,
      default: '$check_box_rounded',
    },
    /**
     * Icone do checkbox quando estiver desmarcado
     */
    offIcon: {
      type: String,
      default: '$check_box_outline_blank_rounded',
    },
    /**
     * Icone do checkbox quando estiver em estado indeterminado
     */
    indeterminateIcon: {
      type: String,
      default: '$indeterminate_check_box_rounded',
    },
    /**
     * Flag para Ocultar erros de dica e validação. Quando definido como `auto`, as mensagens serão renderizadas apenas se houver(dica, mensagem de erro, valor do contador, etc.)
     */
    hideDetails: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para utilizar a variação pequena do componente
     */
    small: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.zoox-checkbox {
  &.small {
    .v-icon {
      font-size: 20px;
    }
    label {
      font-size: var(--zoox-font-size-body3) !important;
    }
    .v-input--selection-controls__input {
      margin-right: 5px;
    }
    .v-input--selection-controls__ripple::before {
      transform: scale(0.9);
    }
  }
}
</style>
